import React,{useState} from 'react'
import styled from "styled-components";
import getImg from "../../../Utils/getImg";

const MainBlock = styled.div`

    // background: pink;
    height:auto;
    margin:20px 0;
    & .tenure-block{
        padding: 0px 10px;
       
    }
    & .tenure-label{
        padding-left: 4px;
        color: #000

    }
    & .EMI_tenure{
        padding-top:10px;
        background: #fff;
        border: 0px solid;
        box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
        border-radius: 4px;
       
    }

    & .radioSelect{
        font-size:14px;
        padding:10px;
        border: 1px solid rgba(0,0,0,0.1);
        border-radius: 6px;
        margin-bottom: 8px;
        display: inline-block;
        color: #003E8D;
        font-weight:500;
        background: none;
    }
`;

const RBLCardSelection=(props)=> {
    const { cardData } = props;

    cardData[0].text += `<br><a href="https://www.rbl.bank.in/product/credit-cards/shoprite-credit-card" target="_blank" >Click here</a> to know more.</br><br>`;
   //  cardData[1].text += `<br><a href="https://www.rbl.bank.in/product/credit-cards/rbl-bank-monthly-treats-credit-card" target="_blank" >Click here</a> to know more.</br><br>`;
    const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
    const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };
    const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);
    let sendData = "";

const handleProceed = () => {
    if (sendData.length != 0) {
      let inputString = "continue" +"<split>" +sendData;
      window["autosubmit"](inputString);
      document.getElementById("showCardData").style.pointerEvents = "none";
      setButtonStyle(buttonStyleDisabled);
    } else {
      props.overlayMessageToggle("Please select a Card.");
    }
  };

const handleRadioChange = (selectedCard) => {
    sendData = selectedCard;
  };

  const showCardData = (val) => {
    return (
      <div id="showCardData">
        <MainBlock>
          <div className="tenure-block">
            <div className="">
              {cardData.map((item, i) => {
                return (
                    <React.Fragment  key={i}>
                  <div
                    className="radioSelect disable-item"
                    onChange={() => handleRadioChange(item.radio_text)}
                  >
                    <input
                      type="radio"
                      style={{ cursor: "pointer" }}
                      name="checkbox"
                    />
                   <label style={{ marginLeft: "1px" }}>{item.radio_text}</label>
                  </div>
                <div
                 dangerouslySetInnerHTML={{
                    __html: item.text
                  }}></div>
                  <div style={{width: "100%", textAlign: "center"}}>

                  <img src={getImg(item.image.split("#image#")[1])} alt="image not found" width="120px" margin="auto" height="90px" onClick={()=>{props.overlayImageModalToggle("#ImagePath#"+"#RBLIMG#"+getImg(item.image.split("#image#")[1]))}} />
                 
                  </div>
                  
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </MainBlock>
      </div>
    );
  };
  return (
    <React.Fragment>
      {showCardData()}
      <div className="action-elem" onClick={() => handleProceed()}>Submit</div>
    </React.Fragment>
  );
}
export default RBLCardSelection;